function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CosmicCubeReporter from './CosmicCubeReporter';
/**
 * The GriefReport component is a wrapper around the iframe based Cosmic Cube micro frontend.
 *
 * - [Cosmic Cube Docs](https://confluence.sie.sony.com/display/COS/Cosmic+Cube+API+Spec)
 *
 * ## Configuration
 *
 * ```js
 * GriefReport.configure({
 *  npEnvironment: 'e1-np',
 *  isDryRun: false,
 *  locale: 'en_US',
 * });
 * ```
 *
 * ## Usage
 *
 * ```jsx
 * <GriefReport
 *  target={[{ type: 'OnlineId', onlineId: 'DD31' }]}
 *  flow="standard"
 *  onClose={({ action, target }) => console.log(action, target)}
 * />
 *```
 *
 * ## Props
 */

var GriefReport = /*#__PURE__*/function (_PureComponent) {
  _inherits(GriefReport, _PureComponent);

  var _super = _createSuper(GriefReport);

  _createClass(GriefReport, null, [{
    key: "configure",
    value: function configure(config) {
      GriefReport.config = _objectSpread(_objectSpread({}, GriefReport.config), config);
    }
  }]);

  function GriefReport(props) {
    var _this;

    _classCallCheck(this, GriefReport);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      return _this._cosmicCube.close();
    });

    _this._node = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(GriefReport, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          target = _this$props.target,
          flow = _this$props.flow,
          onOpen = _this$props.onOpen,
          onLoad = _this$props.onLoad,
          onError = _this$props.onError,
          onData = _this$props.onData,
          onClose = _this$props.onClose;
      this._cosmicCube = new GriefReport.Reporter(GriefReport.config);

      this._cosmicCube.on('open', onOpen);

      this._cosmicCube.on('load', onLoad);

      this._cosmicCube.on('data', onData);

      this._cosmicCube.on('close', onClose);

      this._cosmicCube.on('error', onError);

      this._cosmicCube.beginReport(target, {
        parentEl: this._node.current,
        flow: flow
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._cosmicCube.off();

      this._cosmicCube.cancel();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        ref: this._node,
        className: "psw-fill-x"
      });
    }
  }]);

  return GriefReport;
}(PureComponent);

_defineProperty(GriefReport, "Reporter", CosmicCubeReporter);

_defineProperty(GriefReport, "config", {
  url: 'https://onlinesafetyreport.{envExceptNp}.playstation.com/cc/web/release/',
  npEnvironment: 'e1-np',
  isDryRun: true
});

export default GriefReport;
GriefReport.defaultProps = {
  flow: 'standard',
  onOpen: function onOpen() {},
  onLoad: function onLoad() {},
  onError: function onError() {},
  onData: function onData() {},
  onClose: function onClose() {}
};
GriefReport.propTypes = {
  /**
   * What to grief report. See Cosmic Cube docs for formats and flows
   */
  target: PropTypes.arrayOf(PropTypes.shape({})).isRequired,

  /**
   * Specifies which grief report flow to invoke. See Cosmic Cube docs for usage
   */
  flow: PropTypes.string,

  /**
   * event callback called when grief report is opened (before load)
   */
  onOpen: PropTypes.func,

  /**
   * event callback called when cosmic cube has been loaded in iframe
   */
  onLoad: PropTypes.func,

  /**
   * event callback called when an error occurs
   */
  onError: PropTypes.func,

  /**
   * event callback called when data is available from cosmic cube frame
   */
  onData: PropTypes.func,

  /**
   * event callback called when cosmic cube is closed
   */
  onClose: PropTypes.func
};